export const rtlAnchor = (
  dir = 'RTL',
  anchor: 'RIGHT_CENTER' | 'LEFT_CENTER' | 'BOTTOM_CENTER' | 'TOP_CENTER'
) => {
  if (dir !== 'RTL') {
    return anchor
  }
  switch (anchor) {
    case 'RIGHT_CENTER':
      return 'LEFT_CENTER'
    case 'LEFT_CENTER':
      return 'RIGHT_CENTER'
    default:
      return anchor
  }
}

type Position = 'top' | 'bottom' | 'left' | 'right'

export const rtlRightLeft = (dir = 'RTL', position?: Position) => {
  if (dir !== 'RTL') {
    return position
  }
  switch (position) {
    case 'left':
      return 'right'
    case 'right':
      return 'left'
    default:
      return position
  }
}

export const rtlArrow = (dir = 'RTL', position?: Position | Position[]) => {
  if (!Array.isArray(position)) {
    return rtlRightLeft(dir, position)
  }
  return position.map((p) => rtlRightLeft(dir, p))
}

export const isRTL = (locale?: string) => {
  return locale === 'ar-SA' || locale === 'he-IL'
}
